module.exports = __webpack_public_path__ + "img/guide_logo_2.0aef6b75.png";